import React from 'react';
import { Link } from 'react-router-dom';
import { UserManager } from '../components/admin/UserManager';
import { useAuth } from '../hooks/useAuth';
import { initDb } from '../lib/api';

export const AdminPage: React.FC = () => {
  const { user, logout } = useAuth();

  const handleInitDb = async () => {
    if (!confirm('Initialize the database schema? This is safe to run multiple times (uses CREATE IF NOT EXISTS).')) return;
    try {
      const result = await initDb();
      alert(result.message);
    } catch (err) {
      alert(`Error: ${err instanceof Error ? err.message : 'Unknown error'}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Bar */}
      <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="text-blue-600 hover:text-blue-800 text-sm hover:underline"
          >
            ← Back to Editor
          </Link>
          <span className="text-gray-300">|</span>
          <h1 className="text-base font-semibold text-gray-900">
            Admin — Research Editor
          </h1>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={handleInitDb}
            className="px-3 py-1.5 text-xs text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
            title="Initialize D1 database schema (safe to run multiple times)"
          >
            Init DB Schema
          </button>

          {user && (
            <div className="flex items-center gap-2">
              {user.picture && (
                <img
                  src={user.picture}
                  alt=""
                  className="w-7 h-7 rounded-full"
                />
              )}
              <span className="text-sm text-gray-700">{user.name}</span>
            </div>
          )}

          <button
            onClick={logout}
            className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
          >
            Sign Out
          </button>
        </div>
      </header>

      <main>
        <UserManager />
      </main>
    </div>
  );
};
